module.exports = __webpack_public_path__ + "static/media/Concerto-Logo.6357e4dd.png";